<!--リストコントロール-->
<!--カード選択状態の管理・ロードスピナー・バーチャルスクロール機能を提供します-->
<template>
  <div class="cx_grid" :style="defaultStyle" v-resize="onResize">
    <div class="cx_listbox_content">
      <div class="thead  spinner_parent" ref="listHead">
        <div class="spinner_header" v-if="isLoading"></div>
        <table :style="{'min-width' : tableWidth}">
          <colgroup>
            <col v-if="showCheckBox" :width="50" />
            <col v-for="(column, index) in columns" :key="index" :width="column.width" />
            <!-- <col :width="paddingWidthHeader" />-->
            <col width="100%" />            
          </colgroup>
          <thead>
            <tr @mousemove="onMove" @touchmove="onMove">
              <th v-if="showCheckBox" class="control_cell_th" :style="getStickyStyle(-1)">                
                <div class="cx_card_check"><b-form-checkbox v-model="allChecked" size="sm" /></div>
              </th>
              <th v-for="(column, index) in columns" :key="index" :data-item-id="index" :style="getStickyStyle(index)">
                <div class="column">
                  <!-- ドラッグ&ドロップの実装 -->
                  <div class="spacer" :class="{start : index == 0}" />
                  <div class="header" ref="drag" @dragstart="dragStart(index, $event)" @dragover="dragOver(index, $event)" @drop="drop(index, $event)" @touchstart="dragStart(index, $event)" @touchmove="dragMove($event)" @touchend="onTouchEnd(index, $event)">
                    <div class="header_cell start"  :draggable="true" v-if="index == 0" :data-item-id="index">
                      {{ $translate(column.caption) }}
                    </div>
                    <div class="header_cell center"  :draggable="true" v-if="index != 0" :data-item-id="index">
                      {{ $translate(column.caption) }}
                    </div>
                  </div>
                  <div class="sort" v-if="column.sortable">
                    <i class="material-icons small valign" :class="{ active: column.caption == sortCaption }" @click="onSort(column.caption)">{{ column.caption == sortCaption && isDescending == false ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
                  </div>
                  <!-- これだとうまくDiv幅がうまく取れない　-- inline blockにするとどうなるか -->
                  <div class="grip_width" @mousedown="onWidthChangeStart($event, index)" @touchstart="onWidthChangeStart($event, index)"></div>
                </div>
              </th>
              <th class="th_gear">
                <div class="column">
                <div class="spacer" />
                <div class="settings" v-if="showGearButton"><i class="material-icons small valign" @click="onShowSelector">settings</i></div>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="tbody" ref="listView" @scroll="onScroll" tabindex="0" @keydown.up="selectUp" @keydown.down="selectDown" @wheel="wheel" :class="{ focus: hasFocus }">
        <table  :style="{'min-width' : hasVerticalScrollbar ? tableWidth2 : tableWidth}">
          <colgroup>
            <col v-if="showCheckBox" :width="50" />
            <col v-for="(column, index) in columns" :key="index" :width="column.width" />
            <!-- <col v-if="paddingWidth > 0" :width="paddingWidth" /> -->
            <col width="100%" />                        
          </colgroup>
          <tbody>
            <!-- 全レコードのtrを配置する。高さはrowHeightで固定とする -->
            <tr v-for="(item, row) in items" :key="row" :data-item-id="row" ref="listCard" :class="{'active':row == selectedId, 'highlight': highlight, 'even-row': row % 2 ==0}" :style="'height:' + rowHeight + 'px'">
              <td class="control_cell" v-if="showCheckBox" @click="onCardClicked(row,true)" :style="getStickyStyle(-1)">
                <div class="cx_card_check" @click="stopPropagation"><b-form-checkbox v-model="checked[row]" size="sm" @change="onCheckClicked(row)"/></div>
              </td>
              <td v-for="(column, index) in columns" :key="index" :data-item-id="index" class="control_cell" @click="onCardClicked(row,true,true)" :style="getStickyStyle(index)">
                <!-- コントロール配置用スロット 領域外の場合はコンポーネントを配置しない-->
                <slot v-if="row >= fromIndex && row <= toIndex" :name="'col' + column.slot" :item="item" :index="row" :editor="_self" :listItem="item"></slot>
              </td>
              <td class="control_cell"></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td :colspan="captions.length"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="spinner spinner_body" v-if="isLoading">
        <div class="spinner-border text-info" role="status"></div>
        <span>データを取得しています..</span>
        </div>              
    </div>
    <!-- <div class="spinner" v-if="isLoading">
      <div class="spinner-border text-info" role="status"></div>
      <span>データを取得しています..</span>
    </div> -->
    <!-- カラム選択ダイアログ -->
    <b-modal v-model="selectorVisible" title="カラム表示設定" @ok="onOk" :no-close-on-backdrop="true" centered>
      <div class="selector">
        <NumericBox title="カラム固定位置" :value.sync="tempStickyColumn" ref="stickyColumn" :min="0" :max="5" />         
        <div class="tbody">      
          <table class="dialog">
            <colgroup>
              <col width="200" />
            </colgroup>
            <tbody>
              <tr v-for="(column, index) in columnVisiblities" :key="index" :data-item-id="index" :draggable="true" @dragstart="dragStart(index, $event, true)" @dragover="dragOver(index, $event)" @drop="drop(index, $event)" @touchstart="dragStart(index, $event,true)" @touchmove="dragMove($event)" @touchend="onTouchEnd(index, $event)">
                <!-- コントロール配置用スロット-->
                <td class="dialog_cell">
                  <b-form-checkbox v-model="column.visible" size="sm">{{ $translate(column.caption) }}</b-form-checkbox>
                </td>
                <td class="dialog_grip">
                  <i class="material-symbols-outlined small valign">drag_indicator</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import resize from 'vue-resize-directive';
import * as Components from '@/agiles/components';

@Component({
  directives: {
    resize,
  },
})
export default class Grid extends Vue {
  // 初期データはインスタンスプロパティとして宣言できます
  @Prop() public items?: any[];
  @Prop({ default: false }) public isLoading: boolean;
  @Prop({ default: false }) public showCheckBox: boolean;
  @Prop({ default: null }) public height: number;
  @Prop({ default: null }) public width: number;

  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;
  @Prop({ default: null }) public visibles: Array<boolean>; 

  @Prop({ default: '' }) public storageKey: string;
  @Prop({ default: false }) public isDescending: boolean;
  @Prop({ default: '' }) public sortCaption: string;
  @Prop({ default: false }) public sortEnabled: boolean;
  @Prop({ default: null }) public sortCaptions: Array<string>;
  @Prop({ default: 34 }) public rowHeight: number;
  @Prop({ default: true }) public showGearButton: boolean;
  @Prop({ default: false }) public highlight: boolean;
  @Prop({ default: false }) public autoselect: boolean; //1行目の自動選択

  private columns: Array<{ caption: string; width: number; position: number; slot: number; sortable: boolean }> = new Array(); //キャプションと表示幅を表示順に保持する(匿名オブジェクト)
  public get visibleItems() {
    return this.items; //.slice(this.fromIndex, this.toIndex);
  }

  public allChecked :boolean = false;
  public checked: boolean[] = new Array(0);
  public selectedId: number = -1;

  /**フォーカス状態: スタイルにfocusクラスを付与します */
  public hasFocus: boolean = false;

  public hasVerticalScrollbar = false;
  /**フォーカスハンドラ */
  public onFocus(e: any) {
    if (this.$el.contains(e.srcElement)) this.hasFocus = true;
    else this.hasFocus = false;
  }

  public created() {
    //ListBoxの内部要素にFocusがあるかどうかを検証するハンドラを配置します。
    document.body.addEventListener('focusin', this.onFocus, { capture: true });
    document.body.addEventListener('mouseup', this.onMouseUp, { capture: false });
    document.body.addEventListener('touchend', this.onMouseUp, { capture: false });
    this.loadColumns();


  }

  public destroyed() {
    document.body.removeEventListener('focusin', this.onFocus, { capture: true });
    document.body.removeEventListener('mouseup', this.onMouseUp, { capture: false });
    document.body.removeEventListener('touchend', this.onMouseUp, { capture: false });


  }

  /**リストをフォーカス状態にします。 */
  public focus() {
    (this.$refs.listView as HTMLElement).focus();
  }

  public mounted() {
    // this.setPaddingWidth();
    // this.computeVisbleIndex();
    this.onValueChange(this.items,null);
    let observer = new IntersectionObserver(this.computeVisbleIndex, null);
    observer.observe(this.$refs.listView as HTMLElement);    
  }
  public get defaultRowCount(){
    var elm = this.$refs.listView as HTMLElement;
    return Math.ceil(elm.clientHeight / this.rowHeight);
  }
  public get tableWidth():string {
    var total = 0;
    if (this.showCheckBox) total += 50;
    this.columns.forEach(obj => total += obj.width);
    total += 40; //ギアアイコン
    return total + 'px';
  }
  public get tableWidth2():string {
    //縦スクロールバーが表示されている場合、横幅を短くする(ヘッダが連動しなくなるため)
    var total = 0;
    if (this.showCheckBox) total += 50;
    this.columns.forEach(obj => total += obj.width);
    total += 50; //ギアアイコン
    //total -= 17; //縦スクロールバー分の領域を狭くする
    var el = this.$refs.listView as HTMLElement;
    if (el.offsetWidth - el.clientWidth > 0) total -=17; //スクロールバーの幅は17px固定(clientWidthが正しく計算されていない?)。携帯の場合はゼロ
    return total + 'px';
  }
  /**高さを設定します。 */
  public get defaultStyle(): string {
    return (this.height == null ? '' : 'height:' + this.height + 'px;overflow-y:auto;flex:none;') + (this.width ? 'width:' + this.width +'px;':'' );
  }
  @Watch('allChecked')
  public onAllCheckedChanged(newValue: boolean, oldValue: boolean){
    // this.items.forEach((obj, index) => {if(index != this.selectedId)this.checked[index] = newValue;});        
    this.items.forEach((obj, index) => {this.checked[index] = newValue;});    
    //チェック状態に移行する場合は、アクティブ行をセット
    if (newValue && this.selectedId == -1 && this.items.length > 0) this.onCardClicked(0);
    //チェックオフ時にリセットする
    else if (newValue == false) this.selectedId = -1;

  }
  public stopPropagation(arg : Event){
    arg.stopPropagation();
  }
  public onCheckClicked(index:number){
    //変更される前に呼び出される
    if (this.checked[index] && this.selectedId == index){
      //最寄りの行をアクティブ化
      var target = -1;
      this.checked.forEach((value,id) => {
        if (value && id != index && (target == -1 || Math.abs(id - index) < Math.abs(target - index))) target = id;
      });
      this.onCardClicked(target,false);
    } else if (this.checked[index] == false) {
      this.onCardClicked(index, false); //アクティブ状態をトリガー
    } else {
      //複数行選択の判定処理
      this.updateMultiSelection();
    }


  }
  //複数行選択判定プロパティ
  public multiSelection:boolean = false;  
  public updateMultiSelection(){
    this.$nextTick(()=>{
      if (this.checked.filter(obj=>obj).length == 1) this.multiSelection = false;
      else this.multiSelection = true;
    });    
  }
  public onCardClicked(index: number, autoCheck = false, clickEvent = false) {
    this.selectedId = index;
    this.$emit('selected', this.selectedId);

    if (autoCheck && this.checked[index] == false){
      for(var i = 0; i<this.checked.length;i++){
        if (i == index) this.$set(this.checked, i, true);
        else if(this.checked[i]) this.$set(this.checked, i, false);
      }
    }
    
    //複数行選択の判定処理
    this.updateMultiSelection();
    //spMode用にclickイベントを新設(エディタ切替に使用)
    if(clickEvent) this.$emit('click',index);
  }

  public fromIndex: number = 0;
  public toIndex: number = 0;

  public get selectedItems(): any[] {
    const targetList = new Array(0);
    this.items.forEach((obj, index) => {
      if (this.checked[index]) targetList.push(obj);
    });
    return targetList;
  } /**行を選択しスクロールします。 */

  public select(id: number, eventEnabled: boolean = true) {
    // スクロール実施～fromIndex/toIndexは一部しか見えていない状態があるのでスクロール必要な場合がある
    if (id <= this.fromIndex) {
      (this.$refs.listView as HTMLElement).scrollBy(0, -this.computeOffset(id, this.fromIndex));
    } else if (id >= this.toIndex) {
      (this.$refs.listView as HTMLElement).scrollBy(0, this.computeOffset(this.toIndex, id));
    } else {
      this.computeVisbleIndex();
    }
    // 選択処理
    if (eventEnabled) this.onCardClicked(id,true);
  }

  public computeOffset(from: number, to: number) {
    return this.rowHeight * (to - from + 1);
  }
  public resetChecked(){
      this.checked = new Array(this.items.length);
      this.allChecked = false;
      for (let i = 0; i < this.checked.length; i++) {
        this.checked[i] = false;
      }    
  }
  //#region バーチャルスクロール
  @Watch('items')
  public onValueChange(newValue: any[], oldValue: any[]): void {
    // コレクション変更後に呼び出されます(追加・編集・削除)
    // 初回はカードの高さを計測するため全項目を描画する

    if (newValue != oldValue) {
      this.checked = new Array(this.items.length);
      this.allChecked = false;
      for (let i = 0; i < this.checked.length; i++) {
        this.checked[i] = false;
      }

      if (this.$refs.listView) (this.$refs.listView as HTMLElement).scrollTo(0, 0);

      this.$nextTick(()=>this.setPaddingWidth()); //レコード数変更が即反映しない
      this.computeVisbleIndex();

      if (this.items.length > 0 && this.autoselect) this.onCardClicked(0,true);

    } else if(newValue.length > oldValue.length) {
      for (let i = 0; i < newValue.length - oldValue.length; i++) this.checked.splice(this.checked.length, null,false);  
      this.computeVisbleIndex();
    } else {
      this.computeVisbleIndex();      
    }
  }
  public updateChecked(index:number, value:boolean){
    this.$set(this.checked,index,value);
  }

  public onResize() {
    this.setPaddingWidth();
    this.computeVisbleIndex();
    this.$emit('endscrolled');    
  }

  public onScroll(event: any) {
    //ヘッダ側の水平スクロールを合わせる
    (this.$refs.listHead as HTMLElement).scrollTo((this.$refs.listView as HTMLElement).scrollLeft, 0);
    // マウスとコードによるスクロールを処理する
    this.computeVisbleIndex();

    //無限スクロール用にイベントを提供する
    var listView = this.$refs.listView as HTMLElement;
    if (listView.scrollTop + listView.clientHeight * 1.2 >= listView.scrollHeight ) this.$emit('endscrolled');
  }

  public computeVisbleIndex() {
    // 現在のスクロールポジションでfromIndex/toIndexを更新します。
    if (! this.$refs.listView)return;
    
    const ulRect = (this.$refs.listView as HTMLElement).getBoundingClientRect(); // 一つめの明細のスクロールトップを起点にする

    if (this.$refs.listCard == undefined) {
      this.fromIndex = 0;
      this.toIndex = ulRect.height / this.rowHeight;
      return;
    }
    const temp = (this.$refs.listCard as HTMLElement[]).map(obj => obj.getBoundingClientRect().top);
    let height = Math.min.apply(null, temp); //一つ目の明細のスクロールトップ

    //描画領域にあるインデックスを計算
    const margin = 5;
    this.toIndex = this.items.length - 1;
    for (let i = 0; i < this.items.length; i++) {
      //次の明細のtopが表示領域内にある場合にfromIndexをセットする
      if (height <= ulRect.top + margin && height + this.rowHeight > ulRect.top) {
        this.fromIndex = i;
      }
      //次の明細のtopが表示領域外にある場合にtoIndexをセットする
      if (height < ulRect.bottom && height + this.rowHeight >= ulRect.bottom - margin) {
        this.toIndex = i;
      }
      height += this.rowHeight;
    }
    this.$forceUpdate(); // virtualプロパティにバインドした場合と描画時間はそれほど変わらなかったので再描画する

    this.$nextTick(()=>{
      if(this.$api.formatter.hasPendingRequests && this.isFormatting == false) {
        this.isFormatting = true;
        //スクロール時は連続するので300ms 遅延させる
        window.setTimeout(()=>{
            this.isFormatting = false; //ここで保留状態を解除する
            this.$api.formatter.loadPendingLists().then(()=>{this.$forceUpdate();});
          }, 300);
      }
    });
  }
  public isFormatting = false;
  //#endregion

  //#region キースクロール

  public selectUp(event: any) {
    if (this.selectedId > 0) {
      this.select(this.selectedId - 1);
    }
    event.preventDefault();
  }

  public selectDown(event: any) {
    if (this.selectedId < this.items.length - 1) {
      this.select(this.selectedId + 1);
    }
    event.preventDefault();
  }

  public wheel(event: any) {
    // if (event.deltaY >0) this.selectDown(event);
    // else this.selectUp(event);
  }

  //#endregion
  public loadColumns() {
    //カラム固定位置(初期値2)
    var initialValue = (this.captions && this.captions.length > 2 && this.showGearButton && this.$api.spMode == false) ? 2: 0;
    this.stickyColumn = localStorage[this.storageKey + "_stickyColumn"] ? localStorage[this.storageKey + "_stickyColumn"] as number : initialValue;

    //columnsを初期化する
    let temp: Array<{ caption: string; width: number; position: number; visible: boolean; sortable: boolean }> = new Array();
    const setting = localStorage.getItem(this.storageKey);

    if (setting != null) temp = JSON.parse(setting);

    //初期非表示項目の追加〜未設定もしくは項目数が異なる場合は初期全表示として扱う
    var visibles:boolean[] = null;
    if (this.visibles && this.visibles.length == this.captions.length) visibles = this.visibles;
    else visibles = this.captions.map(o => true);

    //columnsは表示カラムを設定する
    this.captions.forEach((caption, index) => {
      const current = temp.find(obj => obj.caption == caption);
      const sortable = this.sortCaptions == null ? false : this.sortCaptions.findIndex(obj => obj == caption) != -1;
      if (current != null && current.visible) {
        //表示カラムを追加する
        this.columns.push({ caption: caption, width: this.widths[index] + current.width, position: index + current.position, slot: index, sortable: sortable });
      } else if (current == null && visibles[index]) {
        //初期表示の場合、新規カラムを追加する
        this.columns.push({ caption: caption, width: this.widths[index], position: index, slot: index, sortable: sortable });
      } else {
      }
    });
    //positionの昇順でソートする
    this.columns.sort((a, b) => a.position - b.position);
  }
  public saveColumns() {
    //columnsを保存する〜初期値から変更されていない場合は、システム設定を優先したいので、表示位置と表示幅の差分を保存する。
    const temp = new Array();
    this.captions.forEach((caption, index) => {
      const current = this.columns.find(obj => obj.caption == caption);
      if (current != null) {
        const currentIndex = this.columns.indexOf(current);
        //表示カラムを保存する
        temp.push({ caption: caption, width: current.width - this.widths[index], position: currentIndex - index, visible: true });
      } else {
        //非表示カラムを保存する
        temp.push({ caption: caption, width: 0, position: 0, visible: false });
      }
    });
    localStorage[this.storageKey] = JSON.stringify(temp);
    localStorage[this.storageKey + "_stickyColumn"] = this.stickyColumn;
  }

  private active = false;
  private offset = 0;
  private start = 0;
  private targetId = 0;
  private targetMode = '';
  private targetColumn: any = null;
  private targetDrag: HTMLElement = null;
  private selectorVisible = false;
  private columnVisiblities: Array<{ caption: string; visible: boolean }> = new Array();
  private paddingWidth: number = 0;
  private paddingWidthHeader: number = 0;

  //表示幅変更
  public onWidthChangeStart(e: any, index: number) {
    this.active = true;
    this.offset = 0;
    this.targetId = index;
    this.targetMode = 'width';
    this.targetColumn = this.columns[index];
    const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
    this.start = location.clientX;
    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }
  }

  public onMove(e: any) {
    //ドロップするまでの移動表示用にoffsetを更新する
    if (this.active) {
      const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
      this.offset += location.clientX - this.start;
      this.targetColumn.width += location.clientX - this.start;
      this.start = location.clientX;
      this.setPaddingWidth();

      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }
    }
  }
  public onMouseUp() {
    if (this.active) {
      this.active = false;
      this.saveColumns();
    }
  }
  private dragX: number;
  private dragY: number;
  private dragTarget: HTMLElement = null;
  private isModalDrag: boolean = false;
  public dragStart(index: number, e: any, isModalDrag:boolean = false) {
    if (this.active) {
      e.preventDefault();
      return;
    }
    this.isModalDrag = isModalDrag;
    this.targetId = index;
    //this.style.opacity = '0.4';  // this / e.target is the source node.

    // const location = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
    // this.dragX = location.clientX;
    // this.dragY = location.clientY;
    // this.dragTarget = e.currentTarget as HTMLElement;
  }

  public dragOver(index: number, e: any) {
    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }

    e.dataTransfer.dropEffect = 'move'; // See the section on the DataTransfer object.

    return false;
  }
  public dragMove(e: any) {
    // ドラッグ中のアイテムをカーソルの位置に追従
    var draggedElem = e.target;
    var touch = e.changedTouches[0];
    e.target.style.position = 'fixed';
    e.target.style.top = touch.clientY + window.scrollY - draggedElem.offsetHeight / 2 + 'px';
    e.target.style.left = touch.clientX + window.scrollX - draggedElem.offsetWidth / 2 + 'px';

    if (e.preventDefault) {
      e.preventDefault(); // Necessary. Allows us to drop.
    }
  }
  public onTouchEnd(index: number, e: any) {
    //TouchEndはTouchStart時の要素に対して発生するのでドロップターゲットを自分で取得
    //data-item-idにindexを設定
    var droppedElem = e.target;
    droppedElem.style.position = '';
    e.target.style.top = '';
    e.target.style.left = '';
    var touch = e.changedTouches[0];
    var dropElement = document.elementFromPoint(touch.clientX, touch.clientY);
    const index2 = (dropElement.getAttribute('data-item-id') as any) as number;

    if(this.isModalDrag){
      const target = this.columnVisiblities[this.targetId];
      this.columnVisiblities.splice(this.targetId, 1);
      this.columnVisiblities.splice(index2, 0, target); 
    } else {
      const target = this.columns[this.targetId];
      this.columns.splice(this.targetId, 1);
      this.columns.splice(index2, 0, target); //前後どちらの移動もindex位置に挿入することになる
      this.saveColumns();
      this.$forceUpdate();
    }

  }
  public drop(index: number, e: any) {
    if (this.isModalDrag) {
      const target = this.columnVisiblities[this.targetId];
      this.columnVisiblities.splice(this.targetId, 1);
      this.columnVisiblities.splice(index, 0, target); 
    } else {
      const target = this.columns[this.targetId];
      this.columns.splice(this.targetId, 1);
      this.columns.splice(index, 0, target); //前後どちらの移動もindex位置に挿入することになる
      this.saveColumns();
      this.$forceUpdate();
    }

  }

  public tempStickyColumn:number = 0;
  public onShowSelector() {
    this.columnVisiblities = new Array();
    this.columns.forEach(column => {
      this.columnVisiblities.push({ caption: column.caption, visible: true });
    });
    this.captions.forEach(caption => {
      if (this.columns.findIndex(item => item.caption == caption) == -1) this.columnVisiblities.push({ caption: caption, visible: false });
    });
    this.tempStickyColumn = this.stickyColumn;
    this.selectorVisible = true;
  }
  public onOk(event: any) {

    if ((this.$refs.stickyColumn as any as Components.IControl).validator.validate() == false) {
      event.preventDefault();
      return;
    }

    this.stickyColumn = this.tempStickyColumn;
    //非表示を処理する
    this.columnVisiblities
      .filter(item => item.visible == false)
      .forEach(item => {
        let index = this.columns.findIndex(col => col.caption == item.caption);
        if (index != -1) this.columns.splice(index, 1);
      });
    //表示を処理する
    this.columns.splice(0,this.columns.length); //クリア
    this.columnVisiblities
      .filter(item => item.visible == true)
      .forEach(item => {
        // let index = this.columns.findIndex(col => col.caption == item.caption);
        let pos = this.captions.findIndex(caption => caption == item.caption);
        const sortable = this.sortCaptions == null ? false : this.sortCaptions.findIndex(obj => obj == item.caption) != -1;
        // if (index == -1) this.columns.push({ caption: item.caption, width: this.widths[pos], position: pos, slot: pos, sortable: sortable });
        this.columns.push({ caption: item.caption, width: this.widths[pos], position: pos, slot: pos, sortable: sortable });
      });
    this.saveColumns();
    this.setPaddingWidth();
    this.$forceUpdate();
  }

  public setPaddingWidth() {
      var el = this.$refs.listView as HTMLElement;
      if (el.clientHeight != 0){
        this.hasVerticalScrollbar =  el.scrollHeight  > el.clientHeight;
        // console.log('scrollbar: '+this.hasVerticalScrollbar + ' scrollHeight:' + el.scrollHeight + ' clientHeight:' + el.clientHeight);
      }

    //cssで対応済み
    // //テーブルサイズが領域より小さい場合にpaddingする
    // let totalWidth = 0;
    // let scrollGap = 0;
    // //縦スクロールバーがない状態で調整した後に縦スクロールバーが表示されると横スクロールバーが発生する。
    // if ((this.$refs.listView as HTMLElement).clientHeight < this.items.length * this.rowHeight) scrollGap = 17;

    // if (this.showCheckBox) totalWidth += 50;
    // this.columns.forEach(column => (totalWidth += column.width));
    // const temp = this.$el.clientWidth - scrollGap - totalWidth - 1;

    // if (scrollGap == 0) this.paddingWidth = temp > 40 ? temp : 40;
    // else this.paddingWidth = temp > 23 ? temp : 23;

    // this.paddingWidthHeader = this.paddingWidth;
    // if (scrollGap > 0) {
    //   this.paddingWidthHeader += 17;
    // }
  }

  public onSort(caption: string) {
    this.$emit('sort', caption);
  }
  
  stickyColumn:number = 2; //indexより1つ大きい値
  public getStickyStyle(index :number){
    var left = (index >=0 && this.showCheckBox ? 50 : 0) + this.columns.filter((obj, pos) =>pos < index).map(obj =>obj.width).reduce((sum, obj) => sum + obj,0);
    return index < this.stickyColumn ? "position:sticky; z-index:99; left:" + left + "px":""; 
  }
}
</script>

<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_grid {
  @extend .cx_vertical_fill;

  border: thin solid lightgray;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f9f9f9;
  .cx_listbox_content {
    @extend .cx_vertical_scroll;
    overflow-y: hidden;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    &:focus {
      outline: 0;
      box-shadow: none;
    }

    .th_gear{
      position:sticky;
      right:0px;
      z-index:99;
      .column{
        justify-content: end;
      }
    }
  }

  .spinner_parent{
    position: relative;
  }
  .spinner_body{
    top : 33px; //ヘッダ部分はOpacityが異なるので別描画する
  }  
  .spinner {
    //背景の一覧を表示
    opacity: 1.0;
  }

  .spinner_header {
    opacity: 0.3;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: white;
  }

  .button {
    // font-size: 14px;
    // height: 28px;

    // padding-top: 2px;
    // margin-top: -3px;
    outline: 0 !important;
    box-shadow: none;
    i {
      font-size: 22px;
    }
  }
  .button_remove {
    width: 30px;
    color: #666666;
    &:hover {
      color: #242020;
    }
    i {
      font-size: 22px;
    }
  }
  .add_div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .header_cell {
    height: 20px;
    font-size: 14px;
    // margin-left: 5px;
    flex: 1;
    // margin-right: 5px;
    white-space: nowrap;
    overflow-x: clip;
    &:active {
      cursor: grabbing;
    }
    &:hover {
      cursor: grab;
    }
    // &.start {
    //   // border-right: 1px solid #ccc;
    // }
    // &.center {
    //   // border-left: 1px solid #fff;
    //   // border-right: 1px solid #ccc;
    // }
    // &.end {
    //   // border-left: 1px solid #fff;
    // }
  }

  .settings {
    // padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: flex-end;

    i {
      color: #555;
      user-select: none;
    }
    :hover {
      color: #007bff;
      cursor: pointer;
    }
    :active {
      color: #246bb6;
      cursor: pointer;
    }
  }

  .control_cell {
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    text-align: left;
    border-bottom: 1px solid #dddddd;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
    background-color: #fff;
  }
  .control_cell_th {
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    text-align: left;
    // border-bottom: 1px solid #dddddd; この行だけコメント
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
    background-color: #fff;
  }  
  .cx_card_check {
    display: flex;
    justify-content: start;
    width: 16px;
    height: 16px;
    position: relative; //これがないとチェックボックスが崩れる
    margin-top:2px;
  }
  .custom-checkbox {
    height: 20px;
    padding-top: 0px;
    min-height: unset;
    position: relative;

    //チェックボックスの位置調整
    padding-left: unset;
    padding-right: unset;
    margin-right: unset;
    .custom-control-label::before,
    .custom-control-label::after{
      left: unset;
      top: unset;
    }    

    input {
      //スタッキングコンテクスト回避
      opacity: unset;
      z-index: unset;
      left : 2px;
    }
  }
  .dialog_cell {
    padding-top: 3px;
    //padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 3px;
    text-align: left;
    //border-bottom: 1px solid #dddddd;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;

    .custom-control-label{
      padding-left: 30px;
    }
    .custom-control-label::after,
    .custom-control-label::before{
      left: 0px;
      top: 0px;      
    }
  }
  .dialog_grip {
    margin-right:20px;
    &:active {
      cursor: grabbing;
    }
    &:hover {
      cursor: grab;
    }    
  }
  .remove_cell {
    display: block;
    padding-top: 10px;
  }

  table {
    // width: fit-content;
    width:100%;
    table-layout: fixed;
    &.dialog{
      width: fit-content;
    }
    th {
      // display: flex;
      border-bottom: 1px solid #ccc;

      border-top: 1px solid #fff;
      height: 32px;
      vertical-align: middle;

      text-align: left;
      overflow: hidden;
      padding: 0;
      background: -webkit-linear-gradient(top, #eee 0%, #e0e0e0);
      background: -moz-linear-gradient(top, #eee 0%, #e0e0e0);
      background: -ms-linear-gradient(top, #eee 0%, #e0e0e0);
      background: -o-linear-gradient(top, #eee 0%, #e0e0e0);
      background: linear-gradient(top, #eee 0%, #e0e0e0);
      background: #e7e7e7;
      background: -webkit-gradient(linear, left top, left bottom, from(#eee), to(#e0e0e0));
    }

    //ホバー
    tr:hover:not(.active) {
      .control_cell {
        // background-color: #f5f9fa;
        cursor: pointer;
      }
    }
    tr:hover:not(.active):not(.highlight) {
      .control_cell {
        background-color: #f5f9fa;
      }
    }    
    tr.highlight.even-row:not(.active) {
      .control_cell {
        background-color: #eff9fc;
      }
    }
    tr.highlight  {
      .control_cell {
        border-bottom: 1px solid #d9e9ee;      
      }
    }    
    tr.active {
      .control_cell {
        background-color: #e4f4fa;
      }
    }

    .column {
      display: flex;
      align-items: center;
      height: 30px;
      background-color: transparent;
    }
    .header {
      height: 30px;
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0px;//flex縮小に必要
    }
    .spacer {
      width: 10px;
      height: 20px;
      background-color: transparent;
      // &:not(.start) {
      //   border-left: 1px solid #fff;
      // }
    }
    .grip_width {
      background-color: transparent;
      width: 8px;
      height: 20px;
      z-index: 98;//カレンダーと干渉
      position: relative;
      // margin-left: 5px;
      // border-right: 1px solid #ccc;
      //borderを疑似要素で描画
      text-align:right;
      &::after {
          content: "";
          line-height: 20px;         
          font-size:18px; 
          border-left: solid 1px #ccc;
          border-right: solid 1px #fff;            
      }      
      &:hover {
        cursor: col-resize;
      }
      &.active {
        background-color: #d1d0d0;
      }
    }

    .sort {
      width: 16px;
      height: 20px;
      z-index: 98; //カレンダーと干渉
      color: #ccc;

      i {
        vertical-align: top;
        user-select: none;
      }
      i:hover {
        cursor: pointer;
      }
      i.active {
        color: #444;
      }
    }
  }
  //選択行(ListBoxフォーカス)
  .focus table tr.active {
    .control_cell {
      background-color: #cae5e9;
    }
  }

  .thead {
    // width: fit-content;
    z-index:0; //スタッキングコンテクストを生成
    overflow-x: hidden;
  }
  .tbody_parent{
    overflow-y: hidden;
    overflow-x: hidden;
  }
  .tbody {
    // width: fit-content;
    overflow-y: auto;
    overflow-x: auto;
    flex: 1;
    &:focus {
      outline: 0;
      box-shadow: none;
    }
  }

  .modal-dialog {
    position: relative;
    // display: table; /* This is important */
    overflow-y: auto;
    overflow-x: auto;
    width: fit-content;
    min-width: 300px;
    max-width: none;
  }

  .selector {
    // height: 400px;
    max-height: 400px;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    padding: 5px 10px 5px 15px;

    .cx_control_input{
      width:120px;
    }
  }
}
</style>
